import { Drawer } from 'antd'
import { useState } from 'react'
import styled from 'styled-components'
import MainButton from '../decorators/MainButton'
import DrawerHeader from '../decorators/DrawerHeader'
import PagesCollapse from '../decorators/PagesCollapse'
import HelperList from '../decorators/HelperList'

const StyledDrawer = styled(Drawer)`
  & .ant-drawer-header,
  & .ant-drawer-body {
    padding: 0;
  }
`

const MoreAboutLayoutA = () => {
  const [open, setOpen] = useState(false)

  const handleOpenAndClose = () => {
    setOpen(!open)
  }

  return (
    <>
      <MainButton onClick={handleOpenAndClose} />
      <StyledDrawer
        title={<DrawerHeader onClose={handleOpenAndClose} />}
        placement="bottom"
        onClose={handleOpenAndClose}
        open={open}
        closable={false}
      >
        <PagesCollapse onCloseDrawer={handleOpenAndClose} />
        <HelperList />
      </StyledDrawer>
    </>
  )
}

export default MoreAboutLayoutA
